module.exports = __webpack_public_path__ + "img/custom.cc318855.png";